export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";